import { useTranslation } from "react-i18next";
import GenericPicker from "./GenericPicker";
import {
  getLanguageCookie,
  setLanguageCookie,
  supportedLanguages
} from "../../language/LanguageFunctions";
import HelpButton from "./HelpButton";
import { FlagIcon } from "../icons/FlagIcon";
import { useContext } from "react";
import { AuthContext } from "../user/BCPAuthProvider";
import { Box } from "@mui/material";
import { getLocalStorage } from "../layout/cookies/CookieFunctions";

const LanguageSelector = (props) => {
  const { type, ...rest } = props;

  const authContext = useContext(AuthContext);
  const isBetaUser = authContext?.authState?.identity?.betaUser === "true";
  const isAdmin = authContext?.authState?.identity?.isAdmin === true;
  const allowTranslations = getLocalStorage("allowTranslations") === "true";

  const language = getLanguageCookie();

  const { i18n, t } = useTranslation("translation", {
    lng: language,
    keyPrefix: "components.LanguageSelector"
  });

  const handleLanguageChange = (event) => {
    setLanguageCookie(event.target.value);
    i18n.changeLanguage(event.target.value);
    window.location.reload();
  };

  if (
    supportedLanguages.length <= 1 ||
    !(isAdmin || isBetaUser || allowTranslations)
  )
    return null;

  const languages = supportedLanguages.map((lang) => ({
    value: lang.value,
    label: (
      <FlagIcon
        countryCode={lang?.countryCode}
        alt={t(lang.label.toLowerCase())}
        countryName={t(lang.label.toLowerCase(), {
          defaultValue: lang.label
        })}
      />
    )
  }));

  if (type === "displayTab") {
    return (
      <Box style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <GenericPicker
          name="language-selector"
          label={t("language")}
          value={language}
          list={languages}
          inclAny={false}
          handleChange={(e) => {
            handleLanguageChange(e);
          }}
          fullWidth
          endAdornment={
            props.helpButton ? (
              <HelpButton
                title={t("languageDescription", {
                  defaultValue:
                    "Select your preferred language for the user interface. Some items may take a page reload to update."
                })}
              />
            ) : null
          }
          {...rest}
        />
      </Box>
    );
  }

  if (type === "mainLayout") {
    const languageMenuItems = supportedLanguages.map((lang) => ({
      title: (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            width: "100%",
            justifyContent: "flex-start"
          }}
        >
          <FlagIcon
            countryCode={lang?.countryCode}
            alt={t(lang.label.toLowerCase())}
            countryName={t(lang.label.toLowerCase(), {
              defaultValue: lang.label
            })}
          />
        </Box>
      ),
      onClick: () => {
        setLanguageCookie(lang.value);
        i18n.changeLanguage(lang.value);
        window.location.reload();
      },
      sx: {
        width: "100%",
        justifyContent: "flex-start"
      }
    }));

    return {
      title: t("language", { defaultValue: "Language" }),
      children: languageMenuItems
    };
  }

  return null;
};

export default LanguageSelector;
